import {isUndefined} from 'lodash';
import {useCallback, useRef} from 'react';

import {useVariableHeightContext} from './variableHeightContext';

/*
 * Hook.
 */

/** Returns a function to report the height of something over time. */
export function useVariableHeightChangeReporter(): (arg: number | undefined) => void {
  const {onHeightChange} = useVariableHeightContext();
  const prevHeightRef = useRef<number>();

  return useCallback(
    (height) => {
      const prevHeight = prevHeightRef.current;
      prevHeightRef.current = height;

      if (!onHeightChange || isUndefined(prevHeight) || isUndefined(height) || height === prevHeight) {
        return;
      }

      onHeightChange(prevHeight, height);
    },
    [onHeightChange],
  );
}
